module.exports = __webpack_public_path__ + "assets/img/effect_(4).7f77a4e6.gif";